import { TransactionHistoryRequestModel } from "app/based/baseApiModel/baseTransactionHistory/TransactionHistoryRequestModel";

export class NiceSimRegistrationRequestModel extends TransactionHistoryRequestModel {
  code?: string;
  limit?: number;
  carrier?: Array<string>;
  carrierCodes?: Array<string>;
  page?: number;
  phoneNumber?: string;
  pagination?: boolean;
  status?: number;
  numberType?: Array<string>;
  skus?: Array<string>;
  simType?: string;
  created?: Record<string, unknown>[];
  fromDate?: string;
  toDate?: string;
  note?: string;
  store?: Array<string>;
  userRef?: Array<string>;
  partnerCodes?: Array<string>;
  serial?: string;
  order?: string;
  isOnlyStore?: string;
  storeCodes?: Array<string>;
  providerCode?: string;
  serviceCode?: string;
  destinies?: Array<string>;
  numerologies?: Array<string>;
  zodiacs?: Array<string>;
  buyerPhone?: string;
  transRef?: string;
  supplierRefCode?: string;

  constructor(data?: Partial<NiceSimRegistrationRequestModel>) {
    super();
    this.status = data?.status;
    this.code = data?.code;
    this.carrier = data?.carrier;
    this.phoneNumber = data?.phoneNumber;
    this.page = data?.page;
    this.simType = data?.simType;
    this.limit = data?.limit;
    this.serial = data?.serial;
    this.pagination = data?.pagination;
    this.fromDate = data?.fromDate;
    this.toDate = data?.toDate;
    this.numberType = data?.numberType;
    this.note = data?.note;
    this.created = data?.created;
    this.storeCodes = data?.storeCodes;
    this.order = data?.order;
    this.userRef = data?.userRef;
    this.partnerCodes = data?.partnerCodes;
    this.isOnlyStore = data?.isOnlyStore;
    this.providerCode = data?.providerCode;
    this.serviceCode = data?.serviceCode;
    this.zodiacs = data?.zodiacs;
    this.destinies = data?.destinies;
    this.numerologies = data?.numerologies;
    this.carrierCodes = data?.carrierCodes;
    this.skus = data?.skus;
    this.buyerPhone = data?.buyerPhone;
    this.transRef = data?.transRef;
    this.supplierRefCode = data?.supplierRefCode;
  }
}
